var map = {
	"./01_summer_camp.json": [
		522,
		522
	],
	"./02_afterschool_beginner.json": [
		21,
		21
	],
	"./03_afterschool_intermediate.json": [
		823,
		823
	],
	"./04_afterschool_advanced.json": [
		855,
		855
	],
	"./09_private_school_gr4.json": [
		47,
		47
	],
	"./10_private_school_gr5.json": [
		514,
		514
	],
	"./11_private_school_gr6.json": [
		26,
		26
	],
	"./12_public_school_gr4.json": [
		551,
		551
	],
	"./13_public_school_gr5.json": [
		383,
		383
	],
	"./14_public_school_gr6.json": [
		427,
		427
	],
	"./manifest.json": [
		23,
		404
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89;
module.exports = webpackAsyncContext;